document.addEventListener('DOMContentLoaded', () => {
	const animItems = document.querySelectorAll('._animation');
	const animation_pdp_sections = document.querySelectorAll('.animation-pdp-section');
	const icons_pdp_sections = document.querySelectorAll('.icons-pdp-section');

	if(animItems.length > 0) {
		window.addEventListener('scroll', animOnScroll);

		function animOnScroll() {
			for(let index = 0; index < animItems.length; index++) {
				const animItem = animItems[index];
				const firstColumn = animItem.querySelector('.box-with-price');
				const secondColumn = animItem.querySelector('.box-with-designer');
				const animItemHeight = animItem.offsetHeight;
				const animItemOffset = offset(animItem).top;
				const animStart = 1;

				let animItemPoint = window.innerHeight - animItemHeight / animStart;
				if(animItemHeight > window.innerHeight ) {
					animItemPoint = window.innerHeight - window.innerHeight / animStart;
				}

				if((pageYOffset > animItemOffset - animItemPoint) && pageYOffset < (animItemOffset + animItemHeight)) {
					animItem.classList.add('animate');
					smoothHeightChange(secondColumn, animItemHeight, 1200);
					smoothHeightChange(firstColumn, animItemHeight, 1200);

					// const secondColumnHeight = secondColumn.offsetHeight;
					//
					// if(secondColumnHeight === animItemHeight) {
					// }
				} else {
					if(!animItem.classList.contains('_no-animate')) {
						animItem.classList.remove('animate');
					}
				}
			}
		}

		function offset(el) {
			const rect = el.getBoundingClientRect(),
				scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
				scrollTop = window.pageYOffset || document.documentElement.scrollTop;

			return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
		}

		function smoothHeightChange(element, targetHeight, duration = 500) {
			element.style.transition = `height ${duration}ms ease-in-out`;
			element.style.overflow = 'hidden';

			element.style.height = `${targetHeight}px`;

			setTimeout(() => {
				element.style.transition = '';
			}, duration);
		}

		setTimeout(() => {
			animOnScroll();
		}, 300)
	}

	const pushState = history.pushState;
	const replaceState = history.replaceState;

	history.pushState = function (...args) {
		pushState.apply(history, args);
		handleUrlChange();
	};

	history.replaceState = function (...args) {
		replaceState.apply(history, args);
		handleUrlChange();
	};

	window.addEventListener('popstate', handleUrlChange);

	function hiddenSectionIcons() {
		const main_section = document.querySelector('.animation-pdp-section');
		const main_section_title = main_section.querySelectorAll('.animation-pdp-section h2');
		const main_box_with_image = main_section.querySelectorAll('.box-with-image');

		const no_empty_element = Array.from(main_section_title).find(title => title.textContent !== '');
		const no_empty_image = Array.from(main_box_with_image).find(title => title.textContent !== '');

		if(!no_empty_element && !no_empty_image) {
			main_section.style.display = 'none';
		}

		const sections = document.querySelectorAll('.icons-pdp-section');
		sections.forEach(section => {
			const variant_images = section.querySelectorAll('.box-with-image img');

			// const active_element = Array.from(variant_images).find(item => !item.classList.contains('hide'));

			if(variant_images.length <= 0) {
				section.classList.add('hide');
			} else section.classList.remove('hide');
		})
	}

	function handleUrlChange() {
		const urlParams = new URLSearchParams(window.location.search);
		const variant = urlParams.get('variant');


		icons_pdp_sections.forEach(parent => {
			const variant_titles = parent.querySelectorAll('.box-with-icons h2.title');
			const variant_description = parent.querySelectorAll('.box-with-icons .text');
			const variant_icons = parent.querySelectorAll('.box-with-icons .icon_wrapper');

			const images = parent.querySelectorAll('.box-with-image img');

			selectElem(variant, variant_titles);
			selectElem(variant, variant_description);
			selectElem(variant, variant_icons);
			selectElem(variant, images);
		})

		animation_pdp_sections.forEach(parent => {
			const variant_titles = parent.querySelectorAll('.first_image');
			const price_titles = parent.querySelectorAll('.box-with-price .item-price span[data-variant-id]');
			const text_content_titles = parent.querySelectorAll('.content-text .heading');
			const variant_description = parent.querySelectorAll('.content-text .text');

			selectElem(variant, price_titles);
			selectElem(variant, text_content_titles);
			selectElem(variant, variant_description);
			selectElem(variant, variant_titles);

			hiddenSectionIcons();
		})

	}
	handleUrlChange()

	function selectElem(variant, elements) {

		elements.forEach(item => item.classList.add('hide'));
		const current_price = Array.from(elements).filter(item => +item.dataset.variantId === +variant);
		current_price.forEach(item => item.classList.remove('hide'));

		if(!variant && elements.length) {
			const id = elements[0].dataset.variantId;

			elements.forEach(element => {
				if(+element.dataset.variantId === +id) {
					element.classList.remove('hide');

				}
			})
		}
	}
})
